var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-skeleton-loader",
    _vm._b(
      {
        class: _vm.classList,
        attrs: {
          loading: _vm.loading,
          transition: _vm.transition,
          type: _vm.type,
          types: _vm.types
        }
      },
      "v-skeleton-loader",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }